<template>
  <div class="app app-ti_green metransRecord pay-info-page">
    <div class="header">
      <div class="header__top-wrapper">
        <div class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">充值信息</div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-placeholder"></div>

    <div class="wrapper green-wrapper">
      <!-- 金额 & 倒计时 -->
      <section class="pay-hero">
        <div class="pay-hero__amount">
          <span class="pay-hero__currency">¥</span>
          <span class="pay-hero__value">{{ payInfo.info.amount || '0.00' }}</span>
        </div>
        <div class="pay-hero__countdown">
          <span class="pay-hero__countdown-label">请在</span>
          <span class="pay-hero__countdown-time">{{ timeText }}</span>
          <span class="pay-hero__countdown-label">内完成支付</span>
        </div>
      </section>

      <!-- 订单详情 -->
      <section class="detail-card">
        <div v-if="type == 'usdtpay'" class="detail-row detail-row--address">
          <span class="detail-row__label">收款地址</span>
          <div class="detail-row__address-line">
            <span class="detail-row__address-text">{{ payInfo.cardlist.mch_id }}</span>
            <button class="copy-btn" @click="doCopy(payInfo.cardlist.mch_id)">复制</button>
          </div>
        </div>

        <div class="detail-row">
          <span class="detail-row__label">订单号</span>
          <span class="detail-row__value">{{ payInfo.deposit_no }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-row__label">交易时间</span>
          <span class="detail-row__value">{{ payInfo.info.created_at }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-row__label">充值方式</span>
          <span class="detail-row__value detail-row__value--highlight">{{ payInfo.info.paytype }}</span>
        </div>

        <div v-if="type == 'usdtpay'" class="detail-row detail-row--last">
          <span class="detail-row__label">钱包协议</span>
          <span class="detail-row__value detail-row__value--highlight">{{ payInfo.cardlist.content }}</span>
        </div>
		
		<div v-if="type == 'usdtpay'" class="detail-row detail-row--last">
		  <span class="detail-row__label">实际支付金额</span>
		  <span class="detail-row__value detail-row__value--highlight" style="color: blueviolet;">{{ payInfo.info.real_money }} USDT</span>
		</div>
      </section>
	  

      <!-- 二维码 -->
      <section v-if="payInfo.cardlist && payInfo.cardlist.payimg" class="qrcode-card">
        <p class="qrcode-card__title">扫码支付</p>
        <div class="qrcode-card__box">
          <img :src="payInfo.cardlist.payimg" class="qrcode-card__img" alt="支付二维码" />
        </div>
        <p class="qrcode-card__hint">请使用钱包扫描二维码完成转账</p>
      </section>

      <!-- 底部操作 -->
      <footer class="page-footer">
        <button class="page-footer__btn" @click="$parent.goNav('/transRecord')">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="
            class="page-footer__icon"
            alt=""
          />
          <span>充值完成</span>
        </button>
        <button class="page-footer__btn" @click="$parent.goNav('/transRecord')">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAOVBMVEUMqIcPqIYOqIUOqIYPqIUAr4ALqoVHcEwPp4YOqYcNp4UPqIYPp4UOqIYOqIUIp4cNqYYOqIUPqIbGVSZiAAAAEnRSTlM/0JBw8BAwAMB/YN/goG8gULADspVqAAAAtklEQVQoz42S2xbEEAxFg0hCbzP5/48d2lqL0mnPm2xHboDZL5NeZCwnAW+oA5mdfXX+wEURNWSmCtwpqiRGqj1iyFGAJxZDo1gzaYuUmllpZN/mo7Y9epvvHxvrmZ1v5oBfZZLgR4yOXSLxpYfkMooWHCr6Lp87HH5W2zFRe94xAxarmdGNT7o/UfKd/2VRXKHUyXudAXcD5LKLcn/llPy5JydYzcWl5YYt+QluZplem+8Ye6EfKyMbAQTPPjYAAAAASUVORK5CYII="
            class="page-footer__icon"
            alt=""
          />
          <span>资金明细</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: {
        info: {},
        cardlist: {},
      },
      type: null,
      timer: null,
      m: 0,
      s: 0,
    };
  },
  computed: {
    timeText() {
      const m = this.m >= 10 ? this.m : `0${this.m}`;
      const s = this.s >= 10 ? this.s : `0${this.s}`;
      return `${m}:${s}`;
    },
  },
  created() {
    const { deposit_no } = this.$route.query;
    if (deposit_no) {
      this.getpayinfo(deposit_no);
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    doCopy(msg) {
      const input = document.createElement('input');
      input.style.opacity = '0';
      input.value = msg;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$parent.showTost(1, '复制成功！');
    },
    getpayinfo(deposit_no) {
      this.$parent.showLoading();
      this.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        if (res.code != 200) {
          this.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          this.payInfo = res.data;
          this.type = res.message;
          this.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    countTime() {
      this.clearTimer();
      const createdTime = new Date(this.payInfo.info.created_at).getTime();
      const end = createdTime + 1000 * 60 * 60;
      const leftTime = end - Date.now();

      if (leftTime <= 0) {
        this.m = 0;
        this.s = 0;
        return;
      }

      this.m = Math.floor((leftTime / 1000 / 60) % 60);
      this.s = Math.floor((leftTime / 1000) % 60);
      this.timer = setTimeout(this.countTime, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-info-page {
  min-height: 100vh;
  background: #f6f7f8;
}

.nav-placeholder {
  height: 46px;
}

.wrapper {
  min-height: calc(100vh - 46px);
  padding: 8px 16px 10px;
  box-sizing: border-box;
}

/* 金额区域 */
.pay-hero {
  text-align: center;
  padding: 14px 20px 10px;
  background: var(--commonBg2, #fff);
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.pay-hero__amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 8px;
}

.pay-hero__currency {
  font-size: 20px;
  font-weight: 600;
  color: var(--fontColor1, #333);
  margin-right: 4px;
}

.pay-hero__value {
  font-size: 36px;
  font-weight: 700;
  color: var(--fontColor1, #333);
  line-height: 1;
  letter-spacing: -0.5px;
}

.pay-hero__countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 0;
  font-size: 14px;
  color: #666;
}

.pay-hero__countdown-time {
  display: inline-block;
  min-width: 52px;
  padding: 4px 10px;
  font-size: 16px;
  font-weight: 700;
  color: var(--themeColor, #069b71);
  background: rgba(6, 155, 113, 0.08);
  border-radius: 6px;
  letter-spacing: 1px;
}

/* 详情卡片 */
.detail-card {
  margin-top: 6px;
  padding: 2px 16px;
  background: var(--commonBg2, #fff);
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.detail-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  line-height: 1.5;

  &--address {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  &--last,
  &:last-child {
    border-bottom: none;
  }
}

.detail-row__label {
  flex-shrink: 0;
  min-width: 72px;
  color: #999;
}

.detail-row__value {
  flex: 1;
  text-align: right;
  color: var(--fontColor1, #333);
  word-break: break-all;

  &--highlight {
    color: var(--themeColor, #069b71);
    font-weight: 500;
  }

}

.detail-row__address-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.detail-row__address-text {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 1.4;
  color: #333;
  white-space: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.copy-btn {
  flex-shrink: 0;
  padding: 4px 14px;
  font-size: 12px;
  color: var(--themeColor, #069b71);
  background: rgba(6, 155, 113, 0.08);
  border: 1px solid rgba(6, 155, 113, 0.3);
  border-radius: 14px;
  cursor: pointer;
  line-height: 1.4;

  &:active {
    opacity: 0.7;
  }
}

/* 二维码 */
.qrcode-card {
  margin-top: 6px;
  padding: 10px 16px 10px;
  background: var(--commonBg2, #fff);
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.qrcode-card__title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--fontColor1, #333);
}

.qrcode-card__box {
  display: inline-block;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.qrcode-card__img {
  display: block;
  width: 200px;
  height: 200px;
  border-radius: 4px;
}

.qrcode-card__hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #999;
}

/* 底部按钮 */
.page-footer {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-top: 8px;
  padding-bottom: 6px;
}

.page-footer__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: none;
  font-size: 13px;
  color: var(--themeColor, #069b71);
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

.page-footer__icon {
  width: 22px;
  height: 22px;
}

/* 暗金主题 */
body[data-theme='darkGold'] {
  .pay-info-page {
    background: #171717;
  }

  .pay-hero,
  .detail-card,
  .qrcode-card {
    background: #2e2e2e;
    box-shadow: none;
  }

  .pay-hero__currency,
  .pay-hero__value {
    color: #ffda90;
  }

  .pay-hero__countdown {
    color: #93866b;
  }

  .pay-hero__countdown-time {
    color: #ffda90;
    background: rgba(255, 218, 144, 0.1);
  }

  .detail-row {
    border-bottom-color: #3a3a3a;
  }

  .detail-row__label {
    color: #93866b;
  }

  .detail-row__value {
    color: #ffda90;
  }

  .detail-row__address-text {
    color: #ffda90;
  }

  .detail-row__value--highlight {
    color: #ffda90;
  }

  .copy-btn {
    color: #ffda90;
    background: rgba(255, 218, 144, 0.1);
    border-color: rgba(255, 218, 144, 0.3);
  }

  .qrcode-card__title {
    color: #ffda90;
  }

  .qrcode-card__box {
    background: linear-gradient(180deg, #ffe687, #f0b762);
    border: none;
  }

  .qrcode-card__hint {
    color: #93866b;
  }

  .page-footer__btn {
    color: #ffda90;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue